<div class="review-form">
  <!-- not rated yet, or choosing: the stars are the control -->
  <div class="review-head" *ngIf="!review || editing">
    <span class="review-label">{{ review ? 'Edit Your Rating' : label }}</span>
    <div class="review-stars" role="radiogroup" aria-label="Your rating" (mouseleave)="hover = 0">
      <button type="button" *ngFor="let s of stars"
              class="review-star"
              [class.on]="s <= shown()"
              role="radio"
              [attr.aria-checked]="s === rating"
              [attr.aria-label]="s + (s === 1 ? ' star' : ' stars')"
              (mouseenter)="hover = s"
              (focus)="hover = s"
              (blur)="hover = 0"
              (click)="pick(s)">★</button>
    </div>
  </div>

  <!-- the rest of the form once a star is chosen -->
  <form class="review-body" *ngIf="editing" (ngSubmit)="submit()">
    <label class="review-field">
      <span>{{ requireText ? 'Your Review' : 'Your Review (Optional)' }}</span>
      <textarea name="comment" rows="3" [(ngModel)]="comment" [maxlength]="maxComment" [required]="requireText"
                placeholder="What do you like about it?"></textarea>
    </label>
    <label class="review-field review-name">
      <span>{{ requireText ? 'Your Name' : 'Name Shown' }}</span>
      <input name="displayName" type="text" maxlength="40" [(ngModel)]="displayName" [placeholder]="namePlaceholder" [required]="requireText">
    </label>
    <p class="review-error" *ngIf="error">{{ error }}</p>
    <div class="review-actions">
      <button type="submit" class="review-submit" [disabled]="sending || !canSubmit">{{ sending ? 'Saving…' : 'Submit Review' }}</button>
      <button type="button" class="review-cancel" (click)="cancel()" [disabled]="sending">Cancel</button>
    </div>
  </form>

  <!-- rated: the stars read back, with an Edit link -->
  <div class="review-done" *ngIf="review && !editing">
    <span class="review-stars static" [attr.aria-label]="'Your rating: ' + review.rating + ' of 5'">
      <span *ngFor="let s of stars" class="review-star" [class.on]="s <= review.rating">★</span>
    </span>
    <span class="review-thanks">Thanks For Your Review</span>
    <button type="button" class="review-edit" (click)="edit()">Edit</button>
    <p class="review-note" *ngIf="statusNote">{{ statusNote }}</p>
  </div>
</div>
